import { useCurrentUser } from "@/hooks/use-current-user";
import { signIn } from "next-auth/react";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";

export const useReferFriend = () => {
  const user = useCurrentUser();
  const { showModal } = useGlobalModalContext();

  const showInviteFriendModal = () => {
    if (!user) {
      signIn();
      return;
    }

    showModal({ type: "refer_friend" });
  };

  return {
    showInviteFriendModal,
  };
};
